<div class="sandbox-page">
  <app-header></app-header>
  
  <div class="sandbox-page--content">
    <app-asset-header [config]="headerConfig"></app-asset-header>
    
    <!-- Main Content -->
    <div class="sandbox-page--main">
      <div class="sandbox-page--container">
        <div class="sandbox--workspace-section">
          <div class="sandbox--workspace-content">
            <h2 class="sandbox--workspace-title">Launch Your Development Workspace</h2>
            <p class="sandbox--workspace-description">
              Start building by launching a new notebook in your sandbox workspace.
            </p>
          </div>
          <button class="sandbox--create-notebook-btn" (click)="onCreateNotebookClick()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
           Access Notebook
          </button>
        </div>

        <!-- Features Section -->
        <div class="sandbox--features-section">
          <div class="sandbox--features-container">
            <div class="sandbox--features-grid">
              <div class="sandbox--feature-card" *ngFor="let feature of features">
                <div class="sandbox--feature-illustration">
                  <img [src]="feature.image" [alt]="feature.title" />
                </div>
                <h3 class="sandbox--feature-title">{{ feature.title }}</h3>
                <p class="sandbox--feature-description">{{ feature.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Build, Experiment, Deploy Section -->
        <div class="sandbox--capabilities-section">
          <div class="sandbox-page--container">
            <div class="sandbox--capabilities-header">
              <h2 class="sandbox--capabilities-title">Build, Experiment, Deploy</h2>
            </div>
            <p class="sandbox--capabilities-description">
              Explore integrated MLOps, data processing, visualization, and deployment tools in one workspace.
            </p>
            
            <ul class="sandbox--capabilities-list">
              <li class="sandbox--capability-item" *ngFor="let capability of capabilities">
                <svg class="sandbox--capability-checkmark" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="9" fill="var(--primary-color)" stroke="var(--primary-color)" stroke-width="1"/>
                  <path d="M6 10L9 13L14 7" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="sandbox--capability-text">{{ capability }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <app-footer></app-footer>
  
  <!-- Login Modal -->
  <app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>
</div>
